/** @format */

import { Position, Toaster } from '@blueprintjs/core';

export const AppToaster = Toaster.create({
  className: 'recipe-toaster',
  position: Position.BOTTOM,
  // Weird Blueprint bug where if we make maxToasts 1, the file upload progress toast (fileUtils.js) dismisses itself.
  // TODO: figure out what the hell is up with blue print
  maxToasts: 3,
});
